import React, { useState, useEffect, useRef } from 'react';
import apiService from '../services/api.service';
import Webcam from 'react-webcam';
import Select from 'react-select';
import './Visitor.css';

const DEFAULT_TERMS = [
  "एक रजिस्ट्रेशन सिर्फ़ एक व्यक्ति कि लिए मान्य है।",
  "रजिस्ट्रेशन करने के समय कृपया दिये गये जानकारी की जाँच अवश्य कर लें अन्यथा ग़लत जानकारी पर प्रवेश वर्जित है।",
  "अपना पहचान पत्र संख्या अवश्य मिला लें।",
  "प्रदर्शनी में तीन हॉल हैं और आपको तीनों हॉल में घूमना अनिवार्य है।",
  "18 वर्ष से कम उम्र के व्यक्तियों के लिए प्रवेश नहीं है।",
  "यह प्रदर्शनी सिर्फ़ आभूषण व्यापारियों के लिए है।",
  "प्रदर्शनी में किसी भी प्रकार की अस्त्र-सस्त्र और अग्निसमक पदार्थ पूर्णयतः वर्जित है।",
  "तम्बाकू, गुटका एवं नशीले पदार्र और का सेवन पूर्णयत: वर्जित है।",
  "कृपया अपना साफ़ फ़ोटो एवं आधार कार्ड अपलोड करें।",
  "सुरक्षा वजहों से सबको जाँच अनिवार्य है, आपका सहयोग अपेक्षित है।",
  "प्रदर्शनी में आने के लिए अपने साथ अपना पहचानपत्र एवं अपने दुकान का विज़िटिंग कार्ड या जीएसटी सर्टिफिकेट अवश्य लायें।",
  "किसी भी सहायता के लिए संपर्क करें - 0612-2675064"
];

const Visitor = () => {
  const webcamRef = useRef(null);
  const marqueeRef = useRef(null);
  const [showWebcam, setShowWebcam] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  
  const [formData, setFormData] = useState({
    category: 'Visitor',
    vname: '',
    vphone: '',
    aadhar: '',
    firm: '',
    state: '',
    city: '',
    gst: '',
    bnature: '',
    photo: null,
    photoPreview: '',
    aadharFile: null,
    termsAccepted: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [tokenNumber, setTokenNumber] = useState('');
  const [countdown, setCountdown] = useState(10);
  const [registrationStopped, setRegistrationStopped] = useState(false);
  const [termsAndConditions] = useState(DEFAULT_TERMS);

  const indianStates = [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Pondicherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal"
  ];

  // Convert states to react-select format
  const stateOptions = indianStates.map(state => ({
    value: state,
    label: state
  }));

  const categoryOptions = [
    { value: 'Visitor', label: 'Visitor(विजिटर)' }
  ];

  const businessNatures = [
    { value: 'Retailer', label: 'Retailer (रिटेल)' },
    { value: 'Wholesale', label: 'Wholesale (थोक विक्रेता)' },
    { value: 'Manufacturer', label: 'Manufacturer (निर्माता)' },
    { value: 'Other', label: 'Other (अन्य)' }
  ];

  const returnToRegistration = () => {
    setSubmitted(false);
    setTokenNumber('');
    setCountdown(10);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    if (!submitted) return undefined;

    setCountdown(10);
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const intervalId = setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    const timeoutId = setTimeout(() => {
      setSubmitted(false);
      setTokenNumber('');
      setCountdown(10);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 10000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [submitted]);

  // Webcam capture function
  const capturePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    console.log('Photo captured from webcam:', imageSrc ? 'Present' : 'Failed');
    setCapturedImage(imageSrc);
    setFormData(prev => ({
      ...prev,
      photoPreview: imageSrc
    }));
    setShowWebcam(false);
    // Clear photo error if present
    if (errors.photo) {
      setErrors(prev => ({ ...prev, photo: '' }));
    }
  };

  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      console.log('Photo selected:', {
        name: file.name,
        size: file.size,
        type: file.type
      });
      setFormData(prev => ({
        ...prev,
        photo: file,
        photoPreview: URL.createObjectURL(file)
      }));
      setCapturedImage(null);
      // Clear photo error if present
      if (errors.photo) {
        setErrors(prev => ({ ...prev, photo: '' }));
      }
    }
  };

  const handleAadharUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      console.log('Aadhar file selected:', {
        name: file.name,
        size: file.size,
        type: file.type
      });
      setFormData(prev => ({
        ...prev,
        aadharFile: file
      }));
      // Show confirmation to user
      const fileName = file.name.length > 30 ? file.name.substring(0, 27) + '...' : file.name;
      e.target.nextElementSibling?.remove(); // Remove any existing feedback
      const feedback = document.createElement('div');
      feedback.className = 'text-success mt-1';
      feedback.innerHTML = `✓ ${fileName} selected`;
      e.target.parentElement.appendChild(feedback);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    // Numeric validation for phone and aadhar
    if (name === 'vphone' || name === 'aadhar') {
      const numericValue = value.replace(/[^0-9]/g, '');
      setFormData(prev => ({
        ...prev,
        [name]: numericValue
      }));
    } else if (type === 'checkbox') {
      setFormData(prev => ({
        ...prev,
        [name]: checked
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
    
    // Clear error when user types
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // Handler for react-select dropdowns
  const handleSelectChange = (selectedOption, actionMeta) => {
    const { name } = actionMeta;
    setFormData(prev => ({
      ...prev,
      [name]: selectedOption ? selectedOption.value : ''
    }));
    
    // Clear error when user selects
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.vname.trim()) newErrors.vname = 'Name is required';
    if (!formData.vphone.trim()) newErrors.vphone = 'Phone number is required';
    else if (formData.vphone.length !== 10) newErrors.vphone = 'Phone number must be exactly 10 digits';
    else if (!/^[0-9]{10}$/.test(formData.vphone)) newErrors.vphone = 'Phone number must contain only digits';
    if (!formData.aadhar.trim()) newErrors.aadhar = 'Aadhar number is required';
    else if (formData.aadhar.length !== 12) newErrors.aadhar = 'Aadhar number must be exactly 12 digits';
    else if (!/^[0-9]{12}$/.test(formData.aadhar)) newErrors.aadhar = 'Aadhar number must contain only digits';
    if (!formData.firm.trim()) newErrors.firm = 'Firm name is required';
    if (!formData.state) newErrors.state = 'State is required';
    if (!formData.city.trim()) newErrors.city = 'City is required';
    if (!formData.bnature) newErrors.bnature = 'Business nature is required';
    if (!formData.termsAccepted) newErrors.terms = 'You must accept terms and conditions';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setLoading(true);
      setErrors({}); // Clear previous errors
      
      console.log('Starting form submission...');
      
      // Create FormData for file upload
      const submitData = new FormData();
      submitData.append('category', formData.category);
      submitData.append('vname', formData.vname);
      submitData.append('vphone', formData.vphone);
      submitData.append('aadhar', formData.aadhar);
      submitData.append('firm', formData.firm);
      submitData.append('state', formData.state);
      submitData.append('city', formData.city);
      submitData.append('gst', formData.gst);
      submitData.append('bnature', formData.bnature);
      submitData.append('termsAccepted', formData.termsAccepted);
      
      // Add photo (either captured or uploaded)
      if (capturedImage) {
        console.log('Adding captured image:', capturedImage ? 'Present' : 'Missing');
        submitData.append('image', capturedImage);
      } else if (formData.photo) {
        console.log('Adding uploaded photo:', {
          name: formData.photo.name,
          size: formData.photo.size,
          type: formData.photo.type
        });
        submitData.append('photo', formData.photo);
      } else {
        console.warn('No photo selected or captured!');
      }
      
      // Add aadhar file if uploaded
      if (formData.aadharFile) {
        console.log('Adding aadhar file:', {
          name: formData.aadharFile.name,
          size: formData.aadharFile.size,
          type: formData.aadharFile.type
        });
        submitData.append('aadharFile', formData.aadharFile);
      } else {
        console.log('No aadhar file uploaded');
      }

      console.log('Calling API...');
      const response = await apiService.registerVisitor(submitData);
      console.log('API Response:', response);
      console.log('✅ Registration successful!');
      console.log('📝 Visitor ID:', response.data.visitor_id);
      console.log('🎫 Token Number:', response.data.token);
      console.log('💡 Check admin panel to view uploaded photo and aadhar');
      
      if (response.data.success) {
        setTokenNumber(response.data.token);
        setSubmitted(true);
        // Reset form
        setFormData({
          category: 'Visitor',
          vname: '',
          vphone: '',
          aadhar: '',
          firm: '',
          state: '',
          city: '',
          gst: '',
          bnature: '',
          photo: null,
          photoPreview: '',
          aadharFile: null,
          termsAccepted: false,
        });
        setCapturedImage(null);
      }
    } catch (error) {
      console.error('Full error object:', error);
      console.error('Error response:', error.response);
      console.error('Error message:', error.message);
      
      let errorMessage = 'Failed to submit registration. Please try again.';
      
      if (error.response) {
        // Server responded with error
        console.error('Server error status:', error.response.status);
        console.error('Server error data:', error.response.data);
        errorMessage = error.response.data?.message || `Server error: ${error.response.status}`;
      } else if (error.code === 'ECONNABORTED' || /timeout/i.test(error.message || '')) {
        errorMessage = 'The server is busy. Wait a few seconds and try again. If you already received a token by SMS, do not submit again.';
      } else if (error.request) {
        console.error('No response received:', error.request);
        errorMessage = 'No response from server. Please check your connection.';
      } else {
        // Error setting up request
        console.error('Request setup error:', error.message);
        errorMessage = error.message;
      }
      
      setErrors({ submit: errorMessage });
    } finally {
      setLoading(false);
    }
  };


  if (submitted) {
    return (
      <>
        <div className="page-header">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2>Visitor Registration</h2>
              </div>
              <div className="col-12">
                <a href="/">Home</a>
                <a href="/visitor">Registration</a>
              </div>
            </div>
          </div>
        </div>

        <div className="visitor-success">
          <div className="container">
            <div className="success-card">
              <div className="success-icon">
                <i className="fas fa-check-circle"></i>
              </div>
              <h2>Registration Successful!</h2>
              <p>Thank you for registering for SSVASS National Gems & Jewellery Exhibition 2026 - 21st Edition</p>
              <div className="success-details">
                <h3>Your Token Number</h3>
                <p className="token-number">{tokenNumber}</p>
                <p>Please save this token number for entry to the exhibition.</p>
                <p>Confirmation notifications have been sent via <strong>SMS, WhatsApp, and Email</strong> to your registered contact details.</p>
              </div>
              <p className="redirect-timer">
                Returning to registration in <strong>{countdown}</strong> second{countdown === 1 ? '' : 's'}
              </p>
              <div className="success-actions">
                <button 
                  onClick={returnToRegistration}
                  className="btn-register-more"
                >
                  Register Another Visitor
                </button>
                <a href="/" className="btn-home">
                  Back to Home
                </a>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {/* Page Header Start */}
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>VISITOR REGISTRATION</h2>
            </div>
            <div className="col-12">
              <a href="/">Home</a>
              <a href="/visitor">VISITOR REGISTRATION for 21st Edition - 30 Aug to 01 Sep 2026 at Gyan Bhawan, Gandhi Maidan, Patna has been Started</a>
            </div>
          </div>
        </div>
      </div>
      {/* Page Header End */}

      {registrationStopped && (
        <div className="registration-notice">
          <div className="container">
            <div className="alert alert-info">
              Registration has been Started.
            </div>
          </div>
        </div>
      )}

      {/* Registration Form Section */}
      <div className="visitor-form-section">
        <div className="container pt-md-3 pt-2 pb-md-5 pb-4">
          <h3 className="title-style text-center mb-5">
            VISITOR <span>REGISTRATION for 21st Edition - 30 Aug to 01 Sep 2026 at Gyan Bhawan, Gandhi Maidan, Patna has been Started</span>
          </h3>
          
          <div className="marquee-notice">
            <marquee 
              ref={marqueeRef}
              behavior="scroll" 
              direction="left" 
              scrollAmount="4" 
              onMouseOver={() => marqueeRef.current?.stop()} 
              onMouseOut={() => marqueeRef.current?.start()}
            >
              <h2 className="update-text">UPDATE : <span className="highlight">Visitor Registration has been Started.</span></h2>
            </marquee>
          </div>

          <div className="row contact-block">
            <div className="col-md-7 contact-right">
              <form onSubmit={handleSubmit} className="visitor-form" encType="multipart/form-data">
                {errors.submit && <div className="alert alert-danger">{errors.submit}</div>}
                
                <div className="input-grids">
                  <div className="row">
                    <div className="col-sm-6">
                      <Select
                        name="category"
                        options={categoryOptions}
                        value={categoryOptions.find(opt => opt.value === formData.category)}
                        onChange={handleSelectChange}
                        placeholder="Category"
                        className="react-select"
                        classNamePrefix="select"
                        isSearchable={false}
                        menuPlacement="auto"
                        menuPosition="fixed"
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '45px',
                            borderColor: '#ddd',
                            boxShadow: 'none',
                            '&:hover': {
                              borderColor: '#00a86b'
                            }
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 9999
                          })
                        }}
                      />
                    </div>
                    
                    <div className="col-sm-6">
                      <input 
                        type="text" 
                        name="vname" 
                        placeholder="Your Name (नाम)" 
                        className={`contact-input ${errors.vname ? 'is-invalid' : ''}`}
                        value={formData.vname}
                        onChange={handleInputChange}
                        required 
                      />
                      {errors.vname && <div className="invalid-feedback">{errors.vname}</div>}
                    </div>
                    
                    <div className="col-sm-6">
                      <input 
                        type="text" 
                        name="vphone" 
                        placeholder="Phone (मोबाइल)" 
                        className={`contact-input ${errors.vphone ? 'is-invalid' : ''}`}
                        value={formData.vphone}
                        onChange={handleInputChange}
                        maxLength="10"
                        required 
                      />
                      {errors.vphone && <div className="invalid-feedback">{errors.vphone}</div>}
                    </div>
                    
                    <div className="col-sm-6">
                      <input 
                        type="text" 
                        name="aadhar" 
                        placeholder="Aadhar Number (आधार नंबर)" 
                        className={`contact-input ${errors.aadhar ? 'is-invalid' : ''}`}
                        value={formData.aadhar}
                        onChange={handleInputChange}
                        maxLength="12"
                        required 
                      />
                      {errors.aadhar && <div className="invalid-feedback">{errors.aadhar}</div>}
                    </div>
                    
                    <div className="col-sm-6">
                      <input 
                        type="text" 
                        name="firm" 
                        placeholder="Firm (दुकान का नाम)" 
                        className={`contact-input ${errors.firm ? 'is-invalid' : ''}`}
                        value={formData.firm}
                        onChange={handleInputChange}
                        required 
                      />
                      {errors.firm && <div className="invalid-feedback">{errors.firm}</div>}
                    </div>
                    
                    <div className="col-sm-6">
                      <Select
                        name="state"
                        options={stateOptions}
                        value={stateOptions.find(opt => opt.value === formData.state)}
                        onChange={handleSelectChange}
                        placeholder="Select State (राज्य)"
                        className={`react-select ${errors.state ? 'is-invalid' : ''}`}
                        classNamePrefix="select"
                        isClearable
                        isSearchable
                        menuPlacement="auto"
                        menuPosition="fixed"
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '45px',
                            borderColor: errors.state ? '#dc3545' : '#ddd',
                            boxShadow: 'none',
                            '&:hover': {
                              borderColor: errors.state ? '#dc3545' : '#00a86b'
                            }
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 9999
                          })
                        }}
                      />
                      {errors.state && <div className="invalid-feedback d-block">{errors.state}</div>}
                    </div>
                    
                    <div className="col-sm-6">
                      <input 
                        type="text" 
                        name="city" 
                        placeholder="City (शहर)" 
                        className={`contact-input ${errors.city ? 'is-invalid' : ''}`}
                        value={formData.city}
                        onChange={handleInputChange}
                        required 
                      />
                      {errors.city && <div className="invalid-feedback">{errors.city}</div>}
                    </div>
                    
                    <div className="col-sm-6">
                      <input 
                        type="text" 
                        name="gst" 
                        placeholder="GST (जीएसट अगर हो)" 
                        className="contact-input"
                        value={formData.gst}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-sm-6">
                    <label>Upload Photo (अपना फोटो अपलोड करें) - Optional</label>
                    <input 
                      type="file" 
                      name="photo" 
                      className="contact-input"
                      accept="image/*"
                      onChange={handlePhotoUpload}
                    />
                  </div>
                  
                  <div className="col-sm-6">
                    <label>Click Photo (अपना फोटो क्लिक करें) - Optional</label>
                    <button 
                      type="button" 
                      className="btn btn-secondary w-100"
                      onClick={() => setShowWebcam(true)}
                    >
                      Open Camera
                    </button>
                  </div>
                  
                  {formData.photoPreview && (
                    <div className="col-12 mt-3">
                      <img 
                        src={formData.photoPreview} 
                        alt="Preview" 
                        style={{ maxWidth: '200px', maxHeight: '200px' }}
                      />
                    </div>
                  )}
                  {errors.photo && <div className="col-12 text-danger mt-2">{errors.photo}</div>}
                </div>

                <div className="row mt-3">
                  <div className="col-sm-6">
                    <label>Upload Aadhar (अपना आधार का फोटो अपलोड करें)</label>
                    <input 
                      type="file" 
                      name="aadharFile" 
                      className="contact-input"
                      accept="image/*,application/pdf"
                      onChange={handleAadharUpload}
                    />
                  </div>
                  
                  <div className="col-md-6">
                    <label>Business Nature (अपने व्यापार को चुनें)</label>
                    <Select
                      name="bnature"
                      options={businessNatures}
                      value={businessNatures.find(opt => opt.value === formData.bnature)}
                      onChange={handleSelectChange}
                      placeholder="-Select-"
                      className={`react-select ${errors.bnature ? 'is-invalid' : ''}`}
                      classNamePrefix="select"
                      isClearable
                      isSearchable
                      menuPlacement="auto"
                      menuPosition="fixed"
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: '45px',
                          borderColor: errors.bnature ? '#dc3545' : '#ddd',
                          boxShadow: 'none',
                          '&:hover': {
                            borderColor: errors.bnature ? '#dc3545' : '#00a86b'
                          }
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 9999
                        })
                      }}
                    />
                    {errors.bnature && <div className="invalid-feedback d-block">{errors.bnature}</div>}
                  </div>
                </div>

                <div className="form-check mt-3">
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    name="termsAccepted" 
                    id="termsAccepted"
                    checked={formData.termsAccepted}
                    onChange={handleInputChange}
                  />
                  <label className="form-check-label" htmlFor="termsAccepted">
                    I accept the <a href="#terms">Terms & Conditions</a>
                  </label>
                  {errors.terms && <div className="text-danger">{errors.terms}</div>}
                </div>

                <div className="text-center mt-4">
                  <button 
                    type="submit" 
                    className="btn btn-style btn-style-3"
                    disabled={loading}
                  >
                    {loading ? 'Registering...' : 'Register (सबमिट करें)'}
                  </button>
                </div>

                <div className="terms-section mt-3">
                  <h6>नियम और शर्तें -</h6>
                  {console.log('Rendering terms, count:', termsAndConditions.length)}
                  {termsAndConditions.length === 0 ? (
                    <p>Loading terms...</p>
                  ) : (
                    <ol>
                      {termsAndConditions.map((term, index) => (
                        <li key={index}>{term}</li>
                      ))}
                    </ol>
                  )}
                </div>
              </form>
            </div>

            <div className="col-md-5 ps-lg-5 mt-md-0 mt-5">
              <div className="contact-left">
                <div className="cont-details">
                  <div className="d-flex contact-grid">
                    <div className="cont-left text-center me-3">
                      <i className="fas fa-building"></i>
                    </div>
                    <div className="cont-right">
                      <h6>Company Address</h6>
                      <p>2nd floor Gupta Mansion, Baari path, Bakarganj, Patna-800004</p>
                    </div>
                  </div>
                  
                  <div className="d-flex contact-grid mt-4 pt-lg-2">
                    <div className="cont-left text-center me-3">
                      <i className="fas fa-phone-alt"></i>
                    </div>
                    <div className="cont-right">
                      <h6>Call Us</h6>
                      <p><a href="tel:+919334120877">+91-9334120877</a></p>
                    </div>
                  </div>
                  
                  <div className="d-flex contact-grid mt-4 pt-lg-2">
                    <div className="cont-left text-center me-3">
                      <i className="fas fa-envelope-open-text"></i>
                    </div>
                    <div className="cont-right">
                      <h6>Email Us</h6>
                      <p><a href="mailto:info@ssvassgje.in">info@ssvassgje.in</a></p>
                    </div>
                  </div>
                  
                  <div className="d-flex contact-grid mt-4 pt-lg-2">
                    <div className="cont-left text-center me-3">
                      <i className="fas fa-headphones-alt"></i>
                    </div>
                    <div className="cont-right">
                      <h6>Customer Support</h6>
                      <p><a href="mailto:info@ssvassgje.in">info@ssvassgje.in</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Webcam Modal */}
      {showWebcam && (
        <div className="modal-overlay" onClick={() => setShowWebcam(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Capture Photo - Optional</h3>
              <button 
                type="button" 
                className="close-btn"
                onClick={() => setShowWebcam(false)}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width="100%"
                videoConstraints={{
                  width: 640,
                  height: 480,
                  facingMode: "user"
                }}
              />
            </div>
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-primary"
                onClick={capturePhoto}
              >
                Take Snapshot
              </button>
              <button 
                type="button" 
                className="btn btn-secondary"
                onClick={() => setShowWebcam(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Visitor;
